"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _default = function _default(scaffold, selector) {
  return (0, _objectSpread2["default"])({}, scaffold, {
    data: scaffold.data.bind(null, selector),
    error: scaffold.error.bind(null, selector),
    loaded: scaffold.loaded.bind(null, selector),
    loading: scaffold.loading.bind(null, selector),
    keys: scaffold.keys.bind(null, selector),
    select: scaffold.select.bind(null, selector),
    lastLoadedKey: scaffold.lastLoadedKey.bind(null, selector),
    lastRequestedKey: scaffold.lastRequestedKey.bind(null, selector)
  });
};

exports["default"] = _default;